import { Row, Col, Spacer } from '@amzn/stencil-react-components/layout';
import { H3, Text } from '@amzn/stencil-react-components/text';
import React from 'react';
import Img1 from '../../img/WelcomeSlides/slide4-img1.png';

const Slide4 = () => {
  return (
    <Col alignItems="center">
      <H3>Start exploring</H3>
      <Spacer height={12} />
      <Text>
        Get more information about nudge concepts, check out the exclusive nudge repository, use
        self-service and have your personalized dashboard view.
      </Text>

      <Row flex="1" alignItems="center">
        <Col>
          <img async src={Img1} width={'100%'} />
        </Col>
      </Row>
    </Col>
  );
};

export default Slide4;
